import { reduce } from 'lodash'

const mergeArrayOfObjects = (array, predicate) =>
  reduce(array, predicate || ((acc, item) => ({ ...acc, ...item })), {})

export default mergeArrayOfObjects
